import React from "react";
import "./style.css";
import PropTypes from "prop-types";
import Option from "./Option";

const Toolbar = ({ onSelection, activePanel }) => {
  function toggleFontAws(panelName) {
    return panelName === activePanel
      ? "buttonFontawesome toolbarFontAwsClicked"
      : "buttonFontawesome";
  }

  function toggleLabel(panelName) {
    return panelName === activePanel ? "label toolbarLabelClicked" : "label";
  }

  return (
    <nav className="toolbar">
      {buttons.map((elt) => (
        <Option
          key={elt.name}
          label={elt.label}
          icon={elt.icon}
          onClick={() => onSelection(elt.name)}
          classNameFontAws={toggleFontAws(elt.name)}
          classNameLabel={toggleLabel(elt.name)}
        />
      ))}
    </nav>
  );
};

Toolbar.propTypes = {
  onSelection: PropTypes.func.isRequired,
};

const buttons = [
  { label: "Info", name: "Info", icon: "info-circle" },
  { label: "List", name: "ListPathway", icon: "list-ul" },
  { label: "Config", name: "Config", icon: "cog" },
  { label: "Data", name: "Data", icon: "database" },
  { label: "Fullscreen", name: "Fullscreen", icon: "expand" },
];

export default Toolbar;
